<a
    class="group block w-full bg-transparent"
    [hyundaiRouterLink]="link()"
    [trackingElLabel]="headline()"
    [trackingElTarget]="link()"
    [trackingEnabled]="trackingEnabled()"
    trackingElType="teaser"
    tracking
>
    <ui-m000-c010-image
        [image]="{
            image: image().url,
            desktop: { width: 262, height: 148 },
            tablet: { width: 314, height: 178 },
            mobile: { width: 350, height: 198 },
        }"
        [priority]="isFirstView()"
        [alt]="image().alt ?? ''"
        classList="w-full aspect-[163/92] md:aspect-[262/148]"
        cover
    />
    <div class="flex justify-between gap-12 pt-8 pb-12">
        <div>
            <span class="font-text text-14 lg:text-16 leading-21 lg:leading-27">
                {{ headline() }}
            </span>
        </div>

        <i class="icon-chevron-right group-hover:animate-bouncing-left text-24 text-accent self-start"></i>
    </div>
</a>
